import styled from 'styled-components'

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 60vh;
`

export const Box = styled.div`
  display: flex;
  border: 1px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor12};
  background-color: ${({ theme }) => theme.colors.white};
  flex-direction: column;
  justify-content: center;
  padding: 16px;
`

export { MainWrapper } from '@chegg-wt/core/components/Layouts/styled'
